import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_ARROW_DOWN_TO_LINE: GlameraIconDefinition = {
  name: 'arrow-down-to-line',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-arrow-down-to-line-arrow">
      <path d="M12 17V3"></path>
      <path d="m6 11 6 6 6-6"></path>
    </g>
    <path class="glm-arrow-down-to-line-base" d="M19 21H5"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-arrow-down-to-line-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './arrow-down-to-line.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ArrowDownToLineIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_ARROW_DOWN_TO_LINE;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
